import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { DEAL_PERMISSIONS, ROLES } from 'dashboard/constants/permissions';
import DealsIndex from './pages/DealsIndex.vue';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.CRM,
  permissions: [...ROLES, DEAL_PERMISSIONS],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/deals'),
    name: 'deals_dashboard_index',
    component: DealsIndex,
    meta: commonMeta,
  },
];
